import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sleep, translations } from "../../helpers";
import {
  setIsLoading,
  setErrorMessage,
  setSuccessMessage,
} from "../../store/patient/formEventSlice";
import {
  addScheduleEvent,
  deleteScheduleEvent as deleteEvent,
  setScheduleEvents,
} from "../../store/patient/scheduleEventSlice";
import { deleteScheduleEvent } from "../../store/patient/scheduleSlice";
import {
  updatePatientSurgery,
  onLoadPatientSurgery,
  onFailedPatientSurgery,
  setQuizAnswered,
} from "../../store/patient/patientSurgerySlice";
import { gosafeApi } from "../../api";

export const usePatientSurgeryStore = () => {
  const dispatch = useDispatch();

  const { patientSurgery } = useSelector(
    (state) => state.patient.patientSurgery
  );

  const { scheduleEvent } = useSelector((state) => state.patient.scheduleEvent);

  const startScheduleProcedure = useCallback(
    async ({ type }) => {
      try {
        dispatch(setIsLoading());

        const { id: patientSurgeryId } = patientSurgery.data;
        const { id: scheduleEventId } = scheduleEvent;

        const body = {
          scheduleEventId,
          type,
        };

        /* console.log("body", body);
        console.log("patientSurgeryId", patientSurgeryId);
        await sleep(2000); */

        const { data } = await gosafeApi.put(
          `patientSurgery/byScheduledProcedure/${patientSurgeryId}`,
          body
        );

        // console.log("data", data);

        /* const data = {
          message: "scheduled event successfully",
          scheduleEvent: {
            id: body.scheduleEventId,
            title: "jejej",
            notes: "jejej",
            start: "jejej",
            end: "jejej",
            urlPdf: "jejej",
            state: "jejej",
            patientSurgeryId,
            attended: null,
            type: body.type,
          },
        }; */

        dispatch(addScheduleEvent(data));
        dispatch(deleteScheduleEvent(data));
        dispatch(setSuccessMessage(translations[data.message] || data.message));
        return;
      } catch (error) {
        dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
      }
    },
    [dispatch, scheduleEvent, patientSurgery.data]
  );

  const startCancelProcedure = useCallback(async () => {
    try {
      dispatch(setIsLoading());

      const { id: patientSurgeryId } = patientSurgery.data;
      const { id: scheduleEventId } = scheduleEvent;

      const body = {
        scheduleEventId,
        type: null,
        patientSurgeryId: null,
      };

      // console.log("body", body);
      // console.log("patientSurgeryId", patientSurgeryId);
      // await sleep(2000);

      const { data } = await gosafeApi.put(
        `patientSurgery/byCancelProcedure/${patientSurgeryId}`,
        body
      );

      // const data = {
      //   message: "canceled event successfully",
      //   scheduleEvent: {
      //     id: scheduleEventId,
      //   },
      // };

      dispatch(deleteEvent(data));
      dispatch(setSuccessMessage(translations[data.message] || data.message));
    } catch (error) {
      dispatch(
        setErrorMessage(
          translations[error?.response?.data?.message] ||
            error?.response?.data?.message ||
            error?.message
        )
      );
    }
  }, [dispatch, scheduleEvent, patientSurgery.data]);

  const startScheduleAssessment = useCallback(
    async ({ files, ...formState }) => {
      try {
        dispatch(setIsLoading());

        const { id: patientSurgeryId } = patientSurgery.data;
        const { id: scheduleEventId } = scheduleEvent;

        const body = {
          scheduleEventId,
          ...formState,
        };

        //console.log("files", files);
        // console.log(JSON.stringify(body));

        const validFiles = Array.from(files).filter(
          (file) =>
            file.type === "application/pdf" || file.type.startsWith("image/")
        );

        if (validFiles.length !== files.length) {
          dispatch(setErrorMessage("Solo se permiten imágenes o PDFs"));
          return;
        }

        const formData = new FormData();
        Array.from(files).forEach((file) => {
          formData.append("files", file);
        });
        formData.append("body", JSON.stringify(body));

        const { data } = await gosafeApi.put(
          `patientSurgery/byScheduledAssessment/${patientSurgeryId}`,
          formData
        );

        dispatch(updatePatientSurgery(data));
        dispatch(addScheduleEvent(data));
        dispatch(setSuccessMessage(translations[data.message] || data.message));
        return;
      } catch (error) {
        dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
      }
    },
    [dispatch, scheduleEvent, patientSurgery.data]
  );

  const startCancelScheduledAssessment = useCallback(async () => {
    try {
      dispatch(setIsLoading());

      const { id: patientSurgeryId } = patientSurgery.data;
      const { id: scheduleEventId } = scheduleEvent;

      const body = {
        scheduleEventId,
        type: null,
        patientSurgeryId: null,
      };

      // console.log("patientSurgeryId", id);
      // console.log("body", body);

      const { data } = await gosafeApi.put(
        `patientSurgery/byCancelScheduledAssessment/${patientSurgeryId}`,
        body
      );

      dispatch(updatePatientSurgery(data));
      dispatch(deleteEvent(data));
      dispatch(setSuccessMessage(translations[data.message] || data.message));
      return;
    } catch (error) {
      dispatch(
        setErrorMessage(
          translations[error?.response?.data?.message] ||
            error?.response?.data?.message ||
            error?.message
        )
      );
    }
  }, [dispatch, scheduleEvent, patientSurgery.data]);

  const startSendQuizSatisfaction = useCallback(
    async (response) => {
      try {
        dispatch(setIsLoading());

        const { id: patientSurgeryId } = patientSurgery.data;

        const body = {
          patientSurgeryId,
          responses: response,
        };

        // console.log("body", body);

        // const data = {
        //   message: "quiz answered successfully",
        //   patientSurgery: {
        //     state: "QUIZ_SATISFACTION_ANSWERED",
        //   },
        // };

        // await sleep(2000);

        const { data } = await gosafeApi.post("evaluation/satisfaction", body);

        dispatch(updatePatientSurgery(data));
        dispatch(setSuccessMessage(translations[data.message] || data.message));
        return;
      } catch (error) {
        return dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
      }
    },
    [dispatch, patientSurgery.data]
  );

  const startDefineSessions = useCallback(
    async (formState) => {
      try {
        dispatch(setIsLoading());

        const { id: patientSurgeryId } = patientSurgery.data;

        const body = {
          ...formState,
          numberEvents: formState.numberEvents
            ? Number(formState.numberEvents)
            : null,
        };

        // console.log("patientSurgeryId", patientSurgeryId);
        // console.log("body", body);

        // await sleep(2000);
        // const data = {
        //   message: "sessions defined successfully",
        //   patientSurgery: {
        //     id: patientSurgeryId,
        //     state: body.state,
        //     numberEvents: body.numberEvents,
        //     eventsDefinedBy: body.eventsDefinedBy,
        //   },
        // };

        const { data } = await gosafeApi.put(
          `patientSurgery/defineSessions/${patientSurgeryId}`,
          body
        );

        dispatch(updatePatientSurgery(data));
        dispatch(setSuccessMessage(translations[data.message] || data.message));
        return;
      } catch (error) {
        return dispatch(
          setErrorMessage(
            translations[error?.response?.data?.message] ||
              error?.response?.data?.message ||
              error?.message
          )
        );
      }
    },
    [dispatch, patientSurgery.data]
  );

  const startDecryptKey = useCallback(
    async (key) => {
      try {
        const { data } = await gosafeApi.get(`patient/quiz?key=${key}`);

        dispatch(onLoadPatientSurgery(data));
        dispatch(setScheduleEvents(data));
        return;
      } catch (error) {
        const errorMessage =
          translations[error?.response?.data?.message] ||
          error?.response?.data?.message ||
          error?.message;

        dispatch(onFailedPatientSurgery(errorMessage));
        return;
      }
    },
    [dispatch]
  );

  return {
    // Props
    patientSurgery,

    // Methods
    startScheduleProcedure,
    startCancelProcedure,
    startScheduleAssessment,
    startCancelScheduledAssessment,
    startSendQuizSatisfaction,
    startDefineSessions,
    startDecryptKey,
  };
};
